import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { BlService } from 'src/app/_services/bl/bl.service';
import { BlDetails, ClientesBl } from 'src/app/interfaces/bl.interfaces';

/**
 * Componente de página para crear, consultar o actualizar un lote de cabotaje,
 * resolviendo el contexto (lote regular o de importación por barco) y los datos del BL.
 */
@Component({
  selector: 'app-cabotaje-lote-crear',
  templateUrl: './cabotaje-lote-crear.component.html',
})
export class CabotajeLoteCrearComponent implements OnInit {
  titulo: string = '';
  operation_number: number = 0;
  idCliente: number = 0;
  blDetails: BlDetails = {
    operation_number:     0,
    boats_name:           '',
    operation_type_number:0,
    bl_tonnage:           0,
    customer_name:        null,
    date_time_capture:    '',
    dock_name:            '',
    port_origin_name:     '',
    start_operations:     '',
    end_operations:       '',
    boat_nationality:     '',
    destination_port:     '',
    operation_id:         0,
    docking_date:         '',
    undocking_date:       '',
    bl_master:            '',
    notice_of_readiness:  '',
    remaining_tonnage:    0,
    output_total_tonnage: 0,
    operation_type:       '',
  };
  clientesBl: ClientesBl[] = [];
  loading: boolean = true;
  overlayError: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private blServices: BlService,
  ) { }

  ngOnInit(): void {
    this.blServices.path = '/cabotage/batch-list';
    if (this.router.url.includes('/batch-create')) {
      this.titulo = 'Registrar lote de cabotaje';
    } else if (this.router.url.includes('/batch-detail')) {
      this.titulo = 'Detalle de lote de cabotaje';
    } else {
      this.titulo = 'Actualizar lote de cabotaje';
    }

    if (this.router.url.includes('ship-list')) {
      this.operation_number = Number(this.activatedRoute.snapshot.paramMap.get('shipId'));
      this.idCliente = Number(this.activatedRoute.snapshot.paramMap.get('createId'));
      this.handleCabotageImportBatch();
    } else {
      console.log('regular batch');
      this.loading = false;
      this.blDetails.operation_type_number = 3;
    }
  }

  /**
   * Carga los detalles del BL y la lista de clientes para el flujo de lote de cabotaje de importación por barco.
   */
  handleCabotageImportBatch() {
    this.loading = true;
    this.blServices.getBlId(this.operation_number)
    .pipe(
      switchMap( bldetails => {
        if (!Array.isArray(bldetails) || !bldetails.length) {
          this.overlayError = true;
          return of([]);
        }
        this.blDetails = bldetails[0];
        return this.blServices.getClientesBl(this.blDetails.operation_id);
      })
    )
    .subscribe({
      next: (clientesBl) => {
        this.loading = false;
        if (!Array.isArray(clientesBl)) {
          this.overlayError = true;
          return;
        }
        this.clientesBl = [...clientesBl];
      },
      error: (e) => {
        this.overlayError = true;
      },
    });
  }
}
